// extracted by mini-css-extract-plugin
export var noBorder = "NoBorderCard-module--noBorder--69f52";
export var noBorderContainer = "NoBorderCard-module--noBorderContainer--c6ba7";
export var noBorderHeading = "NoBorderCard-module--noBorderHeading--59a16";
export var noBorderImage = "NoBorderCard-module--noBorderImage--441a0";
export var noBorderImageWrapper = "NoBorderCard-module--noBorderImageWrapper--ec624";
export var noBorderLink = "NoBorderCard-module--noBorderLink--89cb9";
export var noBorderTab = "NoBorderCard-module--noBorderTab--664d4";
export var noBorderTextLink = "NoBorderCard-module--noBorderTextLink--fe2fc";
export var noBorderTextLinkIcon = "NoBorderCard-module--noBorderTextLinkIcon--4a02b";
export var ribbon = "NoBorderCard-module--ribbon--57d86";
export var ribbonContent = "NoBorderCard-module--ribbonContent--613e8";